var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('roe-error-message',{attrs:{"field":_vm.design.plan_has_employer_matching_contributions_picklist_id}},[_c('v-select',{attrs:{"options":[
      { code: 0, label: 'No' },
      { code: 1, label: 'Yes, Same Formula for All Employees' },
      { code: 2, label: 'Yes, Formula Varies by Type of Employee' }
    ],"reduce":function (label) { return label.code; }},on:{"input":function($event){return _vm.resetAttributes(
        _vm.design,
        'plan_has_employer_matching_contributions_picklist_id'
      )}},model:{value:(
      _vm.design.$model.plan_has_employer_matching_contributions_picklist_id
    ),callback:function ($$v) {_vm.$set(_vm.design.$model, "plan_has_employer_matching_contributions_picklist_id", $$v)},expression:"\n      design.$model.plan_has_employer_matching_contributions_picklist_id\n    "}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }